"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultPrivateOptions = void 0;
exports.DefaultPrivateOptions = {
    hostname: "realtime.pubq.dev",
    secure: true,
    port: 443,
    path: "/",
};
